import { request } from './request'


const barrageApi = {
  add:params=>{
    let newp = {
      ...params,
      openid:window.openid
    }
    return request({
      url: "/Barrage/Add",
      data: newp,
      method: "POST"
    })
  },
  
  getList:params=>{
    return request({
      url:"/Barrage/GetList",
      params: {
        openid: window.openid
      },
    })
  },
  delete:params=>{
    let newp = {
      ...params,
      openid:window.openid
    }
    return request({
      url: "/Barrage/BarrageDelete",
      data: newp,
      method: "POST"
    })
  },
  getListByOpenid:params=>{
    return request({
      url:"/Barrage/GetListByOpenid",
      params: {
        openid: window.openid
      }
    })
  }
}

export default barrageApi